import { track } from '@tldraw/tldraw'
import { SliderField } from 'components/Design/SliderField/SliderField'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'

export function radiansToDegrees(radians: number) {
  let degrees = radians * (180 / Math.PI)
  if (degrees > 180) {
    degrees -= 360
  }
  return degrees
}

function degreesToRadians(degrees: number) {
  if (degrees < 0) {
    degrees += 360
  }
  return degrees * (Math.PI / 180)
}

export const Rotation = track(() => {
  const editor = useEditor()

  const currentRadians = editor.getSelectionRotation()
  const currentDegrees = radiansToDegrees(currentRadians)

  const handleChange = (newDegrees: number) => {
    // Avoid -180 becoming 180 by adding a small difference
    const newRadians = degreesToRadians(newDegrees === -180 ? newDegrees + 0.01 : newDegrees)
    const delta = newRadians - currentRadians
    editor.rotateShapesBy(editor.getSelectedShapes(), delta)
  }

  return (
    <SliderField
      label="Rotation"
      unit="Degrees"
      value={currentDegrees}
      onChange={handleChange}
      minValue={-180}
      maxValue={180}
      step={1}
      pinnedValue={0}
    />
  )
})
